<template>
  <div class="row">
    <div class="col-md-12 p-t-20">
      <h5 class="h5">
        <i class="fe fe-activity"></i>LGA Data Distribution by Vulnerable Groups
      </h5>
    </div>

    <div class="col-md-12">
      <div class="card m-b-30">
        <div class="card-body">
          <highcharts :options="chartOptions"></highcharts>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      title: "",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    getDashboardLGA() {
      this.axios
        .get("/api/v1/auth/enrolleesbylgabyvulnerables/2683")
        .then((response) => {
          var data = response.data;
          data;
          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: "Enrollees by Vulnerable Groups",
            },
            subtitle: {
              text: "Distributed by LGA",
            },
            xAxis: {
              categories: response.data.lgas,
              crosshair: true,
            },
            yAxis: {
              min: 0,
              title: {
                text: "Total Enrollees",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
            },
            series: [
              {
                name: "Pregnant Women",
                data: response.data.pregnant,
              },
              {
                name: "Children Under 5",
                data: response.data.children,
              },
              {
                name: "Aged",
                data: response.data.aged,
              },
              // {
              //   name: "Special Needs",
              //   data: response.data.special,
              // },
              {
                name: "People with Disabilties",
                data: response.data.disabilities,
              },
            ],
          };
        });
    },
  },
};
</script>
  
  <style>
</style>
  